import debug from 'debug';

/**
 * @file See the docs/Debugging.md file for more information.
 */

export const debugAnimation = debug('animation');
export const debugAPI = debug('API');
export const debugApp = debug('app');
export const debugAppsflyer = debug('i13n:Appsflyer');
export const debugAv = debug('eureka av');
export const debugCaseTransform = debug('lib:caseTransform');
export const debugCaptchaLogic = debug('captcha.logic');
export const debugConfigService = debug('configService');
export const debugFBAPI = debug('FBAPI');
export const debugGarbo = debug('garbo');
export const debugI13nBugsnag = debug('i13n:Bugsnag');
export const debugI13nBugsnagInfo = debug('i13n:BugsnagInfo');
export const debugI13nGTag = debug('i13n:GTag');
export const debugI13nTinderEvents = debug('i13n:TinderEvents');
export const debugIdle = debug('idle');
export const debugLikesYou = debug('likesYou');
export const debugLocalStorage = debug('localStorage');
export const debugLocation = debug('location');
export const debugMatch = debug('match');
export const debugNotification = debug('notification');
export const debugPersist = debug('persist');
export const debugPrivacy = debug('privacy');
export const debugProfile = debug('profile');
export const debugReport = debug('report');
export const debugRecs = debug('recs');
export const debugServiceWorker = debug('serviceWorker');
export const debugSession = debug('session');
export const debugSettings = debug('setting');
export const debugShowError = debug('error');
export const debugSMS = debug('SMS');
export const debugSvgFillManager = debug('svgFillManager');
export const debugTranslations = debug('translations');
export const debugUpdates = debug('updates');
export const debugUser = debug('user');
export const debugPurchase = debug('purchase');
export const debugWebsocket = debug('websocket');
export const debugEntities = debug('entities');
export const debugCookie = debug('cookies');
